import script from "./OrderBookHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderBookHeader.vue?vue&type=script&setup=true&lang=ts"

import "./OrderBookHeader.vue?vue&type=style&index=0&id=2620346a&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2620346a"]])

export default __exports__